<template>
  <div class="clickable" @click="$emit('node-remove')">
    <i class="mdi mdi-close-circle-outline"></i>
  </div>
</template>

<script>
export default {
  props: {
    node: Object
  }
}
</script>
